import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import GridContainer from '../global/GridContainer/GridContainer';
import SearchInput from '../../components/SearchInput';
import CommunityItem from './components/CommunityItem';
import CommunityMap from './components/CommunityMap';
import MapView from '../Icons/MapView';

const Communities = ({ communities, organisation, getUserOrganisation, getCommunities }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [isMapView, setIsMapView] = useState(false);

  useEffect(() => {
    getCommunities({ search: '' });
    getUserOrganisation();
  }, []);

  useEffect(() => {
    const mapView = searchParams.get('mapview') || false;
    setIsMapView(mapView === 'true' ? true : false);
  }, [searchParams]);

  const onMapPressed = () => {
    setIsMapView(!isMapView);
  };

  const onSearch = (searchText) => {
    setSearch(searchText);
    getCommunities({ search: searchText });
  };

  return (
    <div className="communities-container">
      <GridContainer>
        <div className="communities-container--upper">
          <div className="communities-container-header-back-link" onClick={() => navigate('/home')}>
            <FontAwesomeIcon
              icon={['fas', 'chevron-left']}
              className="feed-group-header-back-link-icon"
            />
            {'Go back'}
          </div>
          <h3 className="title m-0">Community Hub</h3>
          <SearchInput submit={onSearch} placeholder="Search Hubs" />
        </div>
        {isMapView ? (
          <CommunityMap organisation={organisation} communities={communities} />
        ) : (
          <div className="communities-container-hub-list">
            {communities.map((community) => {
              return (
                <CommunityItem
                  key={community.id}
                  id={community.id}
                  title={community.title}
                  imageId={community.image_id}
                  imageData={community.image}
                  description={community.description}
                />
              );
            })}
            {!communities.length && !search ? (
              <p>No community hubs available at the moment.</p>
            ) : null}
            {!communities.length && search ? <p>There are currently no communities, they’ll be added soon.</p> : null}
          </div>
        )}

        {communities.length && organisation && organisation.latitude && organisation.longitude ? (
          <div className="communities-container-float" onClick={onMapPressed}>
            <MapView />
            <p className="communities-container-float__text">
              {!isMapView ? 'Map view' : 'List view'}
            </p>
          </div>
        ) : null}
      </GridContainer>
    </div>
  );
};

export default Communities;
